import React, { FC } from 'react';

import { generatePath, Navigate } from 'react-router-dom';

import { ChatByIdPath } from '~/modules/chat/constants';

/** Root `/` → `/chat/index` so chat UI always mounts under `ChatByIdRoute` (no route-boundary remount). */
const ChatRootRedirect: FC = () => (
  <Navigate to={generatePath(ChatByIdPath, { chatId: 'index' })} replace />
);

export default ChatRootRedirect;
